import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function BISelections(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const headers = [[
        "", "$0", "$10K",
        (<span>$15k/$30k,<br></br>$20k/$40k</span>),
        "$25K/$50K", "$35K/$70K", "$50K/$100K", "$100K+"
    ]];

    const [data, setData] = React.useState([
        ["Total", integer.format(0), integer.format(0), integer.format(0), integer.format(0), integer.format(0), integer.format(0)],
        ["%", percent.format(0), percent.format(0), percent.format(0), percent.format(0), percent.format(0), percent.format(0)]
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/Home/GetBodilyInjurySelections${props.type}`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = [
                [
                    "Total",
                    integer.format(response.bI0),
                    integer.format(response.bI10k),
                    integer.format(response.bI15k30k_20k40k),
                    integer.format(response.bI25k50k),
                    integer.format(response.bI35k70k),
                    integer.format(response.bI50k100k),
                    integer.format(response.bI100kPlus),
                ], [
                    "%",
                    percent.format(response.bI0Percentage / 100),
                    percent.format(response.bI10kPercentage / 100),
                    percent.format(response.bI15k30k_20k40kPercentage / 100),
                    percent.format(response.bI25k50kPercentage / 100),
                    percent.format(response.bI35k70kPercentage / 100),
                    percent.format(response.bI50k100kPercentage / 100),
                    percent.format(response.bI100kPlusPercentage / 100),
                ]
            ];

            if (props.comments?.length > 0) {
                headers.push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row == x[0]);
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={`BODILY INJURY SELECTIONS - ${props.type.toUpperCase()}`}
                loading={loading}
                fixedColumns={1}
                headers={headers}
                rows={data}
                exportName={`BodilyInjurySelections${props.type}`}
            />
        </div>
    );
}
